function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 44,
  cy: 44,
  fill: "currentColor",
  r: 44
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56 44L38 54.392V33.608z",
  fill: "#fff"
});

var SvgPlay = function SvgPlay(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _ref, _ref2);
};

export default SvgPlay;